const root = () => document.getElementById('toasts')!;

interface ToastOptions {
  action?: { label: string; run: () => void };
  /** Called when the toast goes away without the action being used. */
  onExpire?: () => void;
  ms?: number;
}

export function toast(message: string, o: ToastOptions = {}): void {
  const el = document.createElement('div');
  el.className = 'toast';
  const text = document.createElement('span');
  text.textContent = message;
  el.append(text);
  let acted = false;
  if (o.action) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'toast__action';
    btn.textContent = o.action.label;
    btn.addEventListener('click', () => {
      acted = true;
      o.action!.run();
      dismiss();
    });
    el.append(btn);
  }
  root().append(el);
  requestAnimationFrame(() => el.classList.add('is-in'));
  const timer = setTimeout(() => {
    if (!acted) o.onExpire?.();
    dismiss();
  }, o.ms ?? (o.action ? 6000 : 3200));
  function dismiss() {
    clearTimeout(timer);
    el.classList.remove('is-in');
    setTimeout(() => el.remove(), 250);
  }
}
